// @flow
import type { CategoryType, TagDeviceType } from '~/core/constants/actions';
import type { Region } from '~/core/types/devices';
import type { Filter } from '../types';

import * as React from 'react';
import { categories, getFilterDevicesList } from '~/core/constants/actions';
import FilterHeader from './header';
import { FormattedMessage } from 'react-intl';
import messages from '../intl';
import { filtersType } from '../constants';
import IconsList from './icons-list/component';
import { Button, Container, Heading, Line } from './styles';

type Props = {
    changeFilter: (newFilter: Filter) => void,
    currentFilter: Filter,
    productTypesUserOwns: Array<string>,
    region: Region
};
export default ({ changeFilter, currentFilter, productTypesUserOwns, region }: Props) => (
    <Container>
        <FilterHeader />
        <Heading>
            <FormattedMessage {...messages.browseByCategory} />
        </Heading>
        <IconsList
            changeFilter={(selectedItem: CategoryType) => changeFilter({ name: filtersType.BY_CATEGORY, selectedItem })}
            list={categories}
            selectedItem={currentFilter.name === filtersType.BY_CATEGORY ? currentFilter.selectedItem : undefined}
        />
        <Line />
        <Heading>
            <FormattedMessage {...messages.browseByDevice} />
        </Heading>
        <IconsList
            changeFilter={(selectedItem: TagDeviceType) => changeFilter({ name: filtersType.BY_DEVICE, selectedItem })}
            list={getFilterDevicesList(region, productTypesUserOwns)}
            selectedItem={currentFilter.name === filtersType.BY_DEVICE ? currentFilter.selectedItem : undefined}
        />
        <Button
            onClick={() => changeFilter({ name: filtersType.SHOW_ALL })}
            selected={currentFilter.name === filtersType.SHOW_ALL}
        >
            <FormattedMessage {...messages.browseAllActions} />
        </Button>
        <Button
            onClick={() => changeFilter({ name: filtersType.BUILD_YOUR_OWN })}
            selected={currentFilter.name === filtersType.BUILD_YOUR_OWN}
        >
            <FormattedMessage {...messages.buildYourOwn} />
        </Button>
    </Container>
);



// WEBPACK FOOTER //
// ./src/components/widgets/actions/filter/component.js